import { Notification } from "element-ui";
import { api } from "../../gateways/unilabApi";

export default {
  getColoriCard() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-colors/colori_card") // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getColoriSidebar() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-colors/colori_sidebar") // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getColoriHeader() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-colors/colori_header") // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getColoriFooter() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-colors/colori_footer") // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  },

  getColoriBody() {
    return new Promise((resolve, reject) => {
      api
        .get("phe-colors/colori_body") // <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "Attenzione",
            message: error
          });
          reject(error);
        });
    });
  }
};
